var React = require('react');

function Forklift (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96 352a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm528 32h-80V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v416a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-272-32a80 80 0 1 0 80 80 80 80 0 0 0-80-80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M410.8 211.9L332.5 29.1A48 48 0 0 0 288.3 0H144a48 48 0 0 0-48 48v112H48a48 48 0 0 0-48 48v166.23a113.49 113.49 0 0 1 16.8-21.43 112 112 0 0 1 158.4 0 111.19 111.19 0 0 1 31.67 63.2h34.26A112 112 0 0 1 416 340.06v-103a64.23 64.23 0 0 0-5.2-25.16zM352 256h-96l-96-96V64h117.8L352 237.1z","className":"fa-primary","key":2})]);
}

Forklift.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Forklift;

Forklift.default = Forklift;
